
export default function AboutValues() {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Quality Workmanship',
      description:
        'Every detail matters. Our licensed contractors and skilled craftsmen deliver premium finishes that stand the test of time, backed by comprehensive warranties.'
    },
    {
      icon: 'ri-time-line',
      title: 'On-Time Delivery',
      description:
        'We respect your time and investment. Detailed project timelines with milestone tracking ensure your renovation is completed on schedule, every time.'
    },
    {
      icon: 'ri-eye-line',
      title: 'Full Transparency',
      description:
        'No hidden costs, no surprises. Itemised quotations, weekly progress reports, and open communication keep you informed at every stage of construction.'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Client-First Approach',
      description:
        'Your vision drives every decision. We listen, advise, and execute with your best interests at heart, minimising stress and maximising satisfaction.'
    },
    {
      icon: 'ri-award-line',
      title: 'Licensed & Insured',
      description:
        'Full compliance with South African building regulations. Licensed contractors, comprehensive insurance, and engineering sign‑off on all structural work.'
    },
    {
      icon: 'ri-recycle-line',
      title: 'Sustainable Practices',
      description:
        'We prioritise eco‑friendly materials, energy‑efficient solutions, and responsible waste management to minimise our environmental footprint.'
    }
  ];

  return (
    <section className="py-16 md:py-24 lg:py-28 bg-[#FDFBF7]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-20">
          <p className="text-xs font-semibold tracking-widest text-[#D4AF37] uppercase mb-4">
            Our Values
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2A2A2A] leading-tight">
            What Sets Us <span className="font-serif text-[#D4AF37]">Apart</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {values.map((value, index) => (
            <article
              key={index}
              className="bg-white rounded-2xl p-6 md:p-8 shadow-md hover:shadow-xl transition-all duration-400 group"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-[#D4AF37]/10 rounded-2xl mb-4 md:mb-6 group-hover:bg-[#D4AF37]/20 transition-colors">
                <i className={`${value.icon} text-xl md:text-2xl text-[#D4AF37]`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-[#2A2A2A] mb-2 md:mb-3">
                {value.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">{value.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
